import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { TestSubsection } from "./TestSection";
import { Globe, FileSignature, QrCode } from "lucide-react";
import * as tests from "./testDefinitions";

export const CustomerFlowsSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">🌍 Customer Flows</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Globe}
          iconColor="text-teal-600"
          title="Widget Checkout Flow"
          badge={<Badge className="bg-red-500 text-white text-xs">Critical</Badge>}
          tests={tests.widgetCheckoutTests}
          results={testResults.widgetCheckout}
        />
        
        <TestSubsection
          icon={FileSignature}
          iconColor="text-purple-600"
          title="Waiver Signing Flow"
          badge={<Badge className="bg-red-500 text-white text-xs">Critical</Badge>}
          tests={tests.waiverFlowTests}
          results={testResults.waiverFlow}
        />
        
        <TestSubsection
          icon={QrCode}
          iconColor="text-blue-600"
          title="QR Code Scanning Flow"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.qrCodeScanningTests}
          results={testResults.qrCodeScanning}
        />
      </CardContent>
    </Card>
  );
};
